export default __webpack_public_path__ + "static/media/(62).a31b9986.jpg";